import * as React from 'react';
import * as l10n from '../util/l10n';
import * as features from '../util/features';
import globalEvents = require('../util/globalEvents');
import * as help from '../help/help';
import websiteData = require('../util/websiteData');

import AviaryShutdownDialog from './AviaryShutdownDialog';
import AviaryEditorDialog, { AviaryEditorDialogBaseProps } from './AviaryEditorDialog';
import { AviaryPremiumPartnerAuthData, DefaultAviaryTools } from './AviaryEditor';
import IframeImageEditorDialog from "./IframeImageEditorDialog";

export interface DiyEditorDialogProps extends AviaryEditorDialogBaseProps, React.Props<AviaryEditorDialog>  {
    aviaryConfigOverride?: any;
}

export default class DiyEditorDialog extends React.Component<DiyEditorDialogProps, {}> {

    componentDidMount() {
        //log Aviary open action in Adobe Catalyst
        globalEvents.trigger("diy-tracking-aviary-open");
    }

    render() {
        let tools = DefaultAviaryTools;

        const aviaryConfigOverride = Object.assign({
            language: websiteData.getLanguage(),
            tools: tools,
        }, this.props.aviaryConfigOverride);

        const apiAuthenticationData = features.getPayload<any>('aviary').apiAuthenticationData;

        let premiumPartnerAuthData: AviaryPremiumPartnerAuthData = null;

        if (apiAuthenticationData.isPremiumPartner) {
            premiumPartnerAuthData = {
                salt: apiAuthenticationData.salt,
                timestamp: apiAuthenticationData.timestamp,
                signature: apiAuthenticationData.signature,
                encryptionMethod: apiAuthenticationData.encryptionMethod,
            };
        }

        if (features('iframedImageEditor')) {
            return (
                <IframeImageEditorDialog
                    open={true}
                    texts={l10n.getMessages('aviaryDialog') as any}
                    onClose={this.props.onClose}
                    onSave={this.props.onSave}
                    imageUrl={this.props.imageUrl}
                    originalImageUrl={this.props.originalImageUrl}
                />
            );

        } else if (features('aviaryShutdown')) {
            return (
                <AviaryShutdownDialog
                    open={true}
                    onClose={this.props.onClose}
                    />
            );

        } else {
            return (
                <AviaryEditorDialog
                    apiKey={apiAuthenticationData.apiKey}
                    premiumPartnerAuthData={premiumPartnerAuthData}
                    aviaryTranslationsOverride={l10n.getMessages('aviary')}
                    aviaryConfigOverride={aviaryConfigOverride}
                    // we don't have currently type safe translations so should cast to any
                    texts={l10n.getMessages('aviaryDialog') as any}
                    onHelp={this.onHelp}
                    {...this.props}
                    />
            );
        }
    }

    private onHelp = () => {
        help.openTopic('aviary_edit_images_overview');
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/aviary/DiyAviaryEditorDialog.tsx
 **/